import { CheckIcon } from '@chakra-ui/icons';
import { useTheme } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { AiOutlineLine } from 'react-icons/ai';
import { FaArrowDown, FaArrowUp, FaX } from 'react-icons/fa6';

import { CellTypeProps } from '../../interfaces';
import { Content, Text } from './styles';

const Symbol: React.FC<CellTypeProps> = ({
  primaryBackgroundColor,
  backgroundColor,
  value,
  color,
  fontWeight,
  fontSize,
}) => {
  const theme = useTheme();

  const SymbolComponent = useMemo(() => {
    switch (value) {
      case 'true':
        return <CheckIcon color={theme?.colors.green['400']} w={6} h={6} />;
      case 'green_arrow_up':
        return <FaArrowUp color={theme?.colors.green['600']} size={16} />;
      case 'red_arrow_down':
        return <FaArrowDown color={theme?.colors.red['600']} size={16} />;
      case 'red_x':
        return <FaX color={theme?.colors.red['500']} size={16} />;
      case 'yellow_line':
        return <AiOutlineLine color={theme?.colors.yellow['500']} size={20} />;
      case 'false':
        return null;
      default:
        return (
          <Text color={color} fontWeight={fontWeight} fontSize={fontSize}>
            {value}
          </Text>
        );
    }
  }, [value, theme, color, fontWeight, fontSize]);

  return (
    <Content
      style={{
        backgroundColor:
          primaryBackgroundColor || backgroundColor || 'transparent',
      }}
    >
      {SymbolComponent}
    </Content>
  );
};
export default Symbol;
